import type { State } from 'state';
import type { RestUiModificationsData } from 'state/actions/ui-modifications';
import type { UiModificationsEntry } from 'state/persisted/ui-modifications';

const buildStoreKey = (portalId: number, requestTypeId: number) => `${portalId}/${requestTypeId}`;

export const getUiModificationsEntry = (
	state: State,
	portalId: number,
	requestTypeId: number,
): UiModificationsEntry | undefined => {
	const storeKey = buildStoreKey(portalId, requestTypeId);
	return state.persisted.uiModifications?.[storeKey];
};

export const getUiModificationsData = (
	state: State,
	portalId: number,
	requestTypeId: number,
): RestUiModificationsData | undefined => {
	return getUiModificationsEntry(state, portalId, requestTypeId)?.data;
};

export const getUiModificationsError = (
	state: State,
	portalId: number,
	requestTypeId: number,
): string | undefined => {
	return getUiModificationsEntry(state, portalId, requestTypeId)?.error;
};
